import { useMemo } from 'react';
import { formatTrendDisplay } from '@/utils/weeklyReportUtils';

export interface MetricsSnapshot {
  urgentRiskCount?: number;
  highRiskCount?: number;
  totalMonitoredCount?: number;
}
export interface TrendCalculationsResult {
  urgentRiskTrendDisplay: { text: string; arrow: string; className: string };
  highRiskTrendDisplay: { text: string; arrow: string; className: string };
  totalMonitoredTrendDisplay: {
    text: string;
    arrow: string;
    className: string;
  };
}

export const useTrendCalculations = (
  today: MetricsSnapshot | null | undefined,
  yesterday: MetricsSnapshot | null | undefined
): TrendCalculationsResult => {
  return useMemo(() => {
    const urgentRiskTrend = today?.urgentRiskCount - yesterday?.urgentRiskCount;
    const highRiskTrend = today?.highRiskCount - yesterday?.highRiskCount;
    const totalMonitoredTrend =
      today?.totalMonitoredCount - yesterday?.totalMonitoredCount;

    return {
      urgentRiskTrendDisplay: formatTrendDisplay(urgentRiskTrend),
      highRiskTrendDisplay: formatTrendDisplay(highRiskTrend),
      totalMonitoredTrendDisplay: formatTrendDisplay(totalMonitoredTrend),
    };
  }, [
    today?.urgentRiskCount,
    today?.highRiskCount,
    today?.totalMonitoredCount,
    yesterday?.urgentRiskCount,
    yesterday?.highRiskCount,
    yesterday?.totalMonitoredCount,
  ]);
};
